import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VContainer,[_c('h1',{staticClass:"text-h3"},[_vm._v("404 - "+_vm._s(_vm.$t("notFound")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }